import React, {Component} from 'react'
import ProductPrice from '../../ProductsGrid/ProductPrice'
import {containsRentalEquipmentTags, setDailyRentalPrice} from '../../../util/rentalProductHelpers'
import '../../../../styles/components/product-card.scss'
import {isAu, isCa, isNZ} from "@/scripts/util/countryCheck"
import PlaceHolderImage from '../../../../images/placeholder-camera.svg'

function SalesTag(props) {
    const { price = 0, compareAtPrice = 0 } = props
    if (compareAtPrice > price) { 
        // We use the ceiling function here to calculate the top rounded value
        // which translates into a slightly lower percentage for fractions so
        // we do not get in trouble for falsely advertising a higher percentage
        // off.
        const percentage = Math.ceil((price * 100) / compareAtPrice)
        return (
            <div className="product-sale-label">
                <span className="badge badge-red">Sale - {100 - percentage}% off</span>
            </div>
        )
    }
    return null
}

export default class ProductCard extends Component {
    constructor(props) {
        super(props)
        const product = this.props.product
        const image = product.product_image ?? product.image ?? false
        if (image) {
            // Image CDN optimisation @ 200x
            const imageIndex = image.search(`.jpg`)
            this.newURL =
                image.slice(0, imageIndex) +
                `_200x` +
                image.slice(imageIndex)
        }
    }

    /**
     * Takes the condition label generated by getProductConditionLabel, and returns the classname for the condition
     * label.
     *
     * @param conditionLabel String
     * @returns String
     */
    getProductConditionLabelClass(conditionLabel) {
        if (typeof conditionLabel === `string`) {
          return conditionLabel
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, ``)
            .replace(/[\s_-]+/g, `-`)
            .replace(/^-+|-+$/g, ``)
        }

        return `unknown-condition-label`
    }

    getProductConditionLabel(tags = []) {

        for (const tag of tags) {
            const key = tag[0].toLowerCase()
            if (key === `shopcondition`) {
                try {
                    return tag[1]
                } catch (error) {
                    // Silence is golden.
                }
            }
        }

        return `Certified Used`
    }

    generateFeatureText(features = []) {
        let featureDom = `<ul>`
        features.forEach(feature => {
            featureDom += `<li>${feature}</li>`
        })
        featureDom += `</ul>`
        return featureDom
    }

    render() {
        const {product, collection} = this.props

        const compareAtPrice = product.compare_at_price * 100
        const price = product.price * 100
        let product_handle_s = `sprod-`+product.handle
        let productDescription = ``

        const productUrl = collection && collection.url ?
            `${collection.url}/products/${product.handle}` :
            `${window.Shopify.locale === `fr` ? `/fr` : ``}/products/${product.handle}`

        const isRentalEquipment = Object.entries(product.named_tags)
            .map(tag => {
                const tagsArray = new Array()
                const formattedTag = tag.join(`:`).toLowerCase()
                tagsArray.push(formattedTag)
                return tagsArray
            })
            .some(containsRentalEquipmentTags)

        const weeklyRentalProductPrice = product.meta?.dtk?.weeklyrental || null

        const dailyRentalPrice = setDailyRentalPrice(weeklyRentalProductPrice)
        let dimensions = `Dimensions unavailable`
        let dimensions_translated = true
        if (product.meta?.dtk?.depth && product.meta?.dtk?.height && product.meta?.dtk?.width) {
            let units = isCa() ? `in` : `mm`
            dimensions = `${product.meta.dtk.width} ${units}(W) X ${product.meta.dtk.depth} ${units}(D) X ${product.meta.dtk.height} ${units}(H)`
            dimensions_translated = false
        }
        const conditionLabel = this.getProductConditionLabel(Object.entries(product.named_tags))
        const conditionLabelClass = this.getProductConditionLabelClass(conditionLabel)
        const feature_limit = conditionLabelClass == `new` ? 3 : 5

        if (product.body_html_safe && product.body_html_safe.includes(`. Features`)) {
            let parts = product.body_html_safe.split(`. Features `)
            if(parts[1]){
                let features = parts[1].split(`, `)
                if (features.length > feature_limit) {
                    productDescription = this.generateFeatureText(features.slice(0,feature_limit))
                } else {
                    productDescription = this.generateFeatureText(features)
                }
            }
        } else if (product.meta.dtk.features && product.meta.dtk.features.includes(`. Features`)) {
            let parts = product.meta.dtk.features.split(`. Features `)
            if(parts[1]){
                let features = parts[1].split(`, `)
                if (features.length > feature_limit) {
                    productDescription = this.generateFeatureText(features.slice(0,feature_limit))
                } else {
                    productDescription = this.generateFeatureText(features)
                }
            }
        }

        let imageUrl = (product.product_image || product.image) ? this.newURL : PlaceHolderImage
        
        return (
            <div
                className="column column-1-of-5 medium-6 small-6 padding-1x"
                key={product.id}
            >
                <div className="product-card relative background-white">
                    <SalesTag price={product.price} compareAtPrice={product.compare_at_price} />
                    <a href={productUrl} className="content-overlay"></a>
                    <div className="lazyload-container image column small-12">
                        <img
                            src={imageUrl}
                            data-srcset={imageUrl}
                            sizes="(min-width: 768px) 560px, 100vw"
                            className="lazyload-absolute-image lazyload"
                            data-src={imageUrl}
                            loading="lazy"
                        />
                        <div className="prod-title-wrapper prod-left-title">
                            <p
                                className="product-title"
                                title={product.title}
                            >
                                {product.title}
                            </p>
                        </div>
                    </div>
                    <div className="content relative column small-12">
                        <div className="prod-title-parent">
                            <div className="prod-title-wrapper">
                                <p
                                    className="product-title weight-bold align-middle small-margin-top-1x"
                                    title={product.title}
                                >
                                    {product.title}
                                </p>
                            </div>
                            <div className="margin-1x text-center">
                                <span className={`product-condition-label text-small ${conditionLabelClass}`}>
                                    {conditionLabel.toUpperCase()}
                                </span>
                            </div>
                            <div className="dimension-view">
                                <div className={`dimenion-view-wr ${dimensions_translated ? `` : `transifex-ignore`}`}>
                                    {dimensions}
                                </div>
                            </div>
                        </div>
                        <div className="specification-wrapper">
                            <div
                                className="specification-wrapper-inner"
                                id={product_handle_s}
                                dangerouslySetInnerHTML={{__html: productDescription}}
                            >

                            </div>
                        </div>
                        <div className="price-detail-wrapper">
                            <ProductPrice
                                isRentalOnly={isRentalEquipment}
                                outrightPrice={price}
                                compareAtPrice={compareAtPrice}
                                dailyRentalPrice={dailyRentalPrice}
                                showGst={isAu() || isNZ()}
                            />
                            {isAu() || isNZ() ? <p className="align-middle gst-note" >Includes GST</p> : ``}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
